// extracted by mini-css-extract-plugin
module.exports = {"input":"Form_input__2ESfd","button":"Form_button__243jh"};